// Sample data fetching snippet
// const { data: levels, error, loading, fetched } = useFetchApi({ 'url': '/qualification-level/' });

import { useEffect, useState } from "react";
import axiosInstance from "../services/AxiosInstance";

function useFetchApi({
    url
}) {
    const [data, setData] = useState([])
    const [error, setError] = useState(null)
    const [loading, setLoading] = useState([])
    const [fetched, setFetched] = useState(false)

    async function fetchApi() {
        try {
            setLoading(true);
            await axiosInstance(url, { method: 'GET' }).then(res => { setData(res.data) });
            setFetched(true);
        } catch (e) {
            console.error('useFetchAPI Error : ', e?.response);
            setError(e?.response?.data);
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchApi();
        // eslint-disable-next-line
    }, [])

    return {
        data,
        error,
        setData,
        loading,
        fetched
    }
}

export default useFetchApi;